import { Component, Input } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'nejo-error-detail',
    templateUrl: './error-detail.component.html',
    styleUrls: ['./error-detail.component.scss'],
    standalone: false
})
export class ErrorDetailComponent {
  @Input() json;
  @Input() updated;
  public jsonParsed;

  constructor(private readonly modalService: NgbModal) {}

  open(content, event) {
    try {
      event.target.closest('datatable-body-cell').blur();
    } catch (e) {}
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' });
    this.jsonParsed = JSON.parse(this.json);
  }

  close() {
    this.modalService.dismissAll();
  }
}
